import { defineStore } from 'pinia'
import { ref } from 'vue'

export type ApplicationConfirm = {
  title?: string
  description?: string
  active: boolean
  loading: boolean
  confirmText: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  confirmCallback?: () => any
  cancelText: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cancelCallback?: () => any
  closeable: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  closeableCallback?: () => any
}

const confirmDefaults = {
  loading: false,
  confirmText: 'Confirm',
  confirmCallback: undefined,
  cancelText: 'Cancel',
  cancelCallback: undefined,
  closeable: false,
  closeableCallback: undefined,
}

/**
 * This store contains a global confirmation state, and is closely tied to the VApplicationConfirm
 * component, which is responsible for rendering the confirm dialog.
 *
 * @see VApplicationConfirm.vue
 */
export const useConfirmStore = defineStore('confirm', () => {
  const confirm = ref<ApplicationConfirm>({
    title: undefined,
    description: undefined,
    active: false,
    ...confirmDefaults,
  })

  function showConfirm(payload?: Partial<Omit<ApplicationConfirm, 'active'>>): void {
    confirm.value = {
      ...confirmDefaults,
      ...(payload ?? {}),
      active: true,
    }
  }

  function setLoading(loading: boolean) {
    confirm.value = {
      ...confirm.value,
      loading,
    }
  }

  function closeConfirm() {
    confirm.value = {
      ...confirm.value,
      active: false,
    }
  }

  return { confirm, showConfirm, closeConfirm, setLoading }
})
